module.exports = __webpack_public_path__ + "img/xmjmix.2048eeab.jpg";